export const urls = {
  localization: `/localization/messages/v1/_search`,
  pgr_search: `/pgr-services/v2/request/_search`,
  pgr_count: `/pgr-services/v2/request/_count`,
  tech_support_search_employee: `/dfs-tech-support/v1/requests/employee/_search`,
  tech_support_search_citizen: `/dfs-tech-support/v1/requests/_search`,
  tech_support_pgr_update: `/dfs-tech-support/v1/requests/_update`,
  pgr_update: `/pgr-services/v2/request/_update`,
  showcause_search: `/dfs-grm-showcause/showcause/v1/_search`,
  showcause_update: `/dfs-grm-showcause/showcause/v1/_update`,
  showcause_count: `/dfs-grm-showcause/showcause/v1/_count`,
  WorkFlowProcessSearch: `/egov-workflow-v2/egov-wf/process/_search`,
  resolvedWorkFlowProcessSearch: `/pgr-auto-escalate/workflow/process-instance/v1/_search`,
  grm_employee_search: `/pgr-auto-escalate/employees/v1/_search`,
  WorkFlow: `/egov-workflow-v2/egov-wf/businessservice/_search`,
  MDMS: `/mdms-v2/v1/_search`,
  MDMS_V2: `/mdms-v2/v2/_search`,
  egov_mdms: `/egov-mdms-service/v1/_search`,
  dataUrl: `/dashboard-report/report/count`,
  assetsData: `/agent/v1/staticData/_search`,
  cropListData: `/soil-card/v1/fertilizer-crops`,
  fertilizerListData: `/soil-card/v1/fertilizer-codes`,
  weatherSearch: `/weather/weather_data/v1/_filter`,
  weatherDataSearch: `/weather/weather_data/v1/_search`,
  weatherDataNearby: `/weather/weather_data/v1/_nearby`,
  weatherAQI: `/weather/weather_data/aqi/v1/_search`,
  weatherAQIStations: `/weather/weather_data/aqi/stations/v1/_search`,
  farmer_search: `/farmer-profile/v1/_search`,
  FileStore: "/filestore/v1/files",
  FileFetch: "/filestore/v1/files/id",
  UserProfileUpdate: "/user/profile/_update",
  ChangePassword: "/user/password/_update",
  resetPassword: "/user/password/nologin/_update",
  locationDetail: "/dfs-location/v1/_getChildBoundaries",
  location: {
    crops: `farmer-schemes/schemes/application/v1/_get-mapping?apiName=crop`,
    district: `/dfs-location/v1/_getChildBoundaries?boundaryType=District`,
    blocks: `/dfs-location/v1/_getChildBoundaries?boundaryType=Block`,
    panchayats: `/dfs-location/v1/_getChildBoundaries?boundaryType=Panchayat`,
    villages: `/dfs-location/v1/_getChildBoundaries?boundaryType=Village`,
  },
  SchemesDetailInfo: "/farmer-schemes/schemes/v1/_search",
  // Per-farmer eligibility-scoped recommendations. Farmer/CITIZEN derives the
  // farmer from RequestInfo.authToken (no body id). tenantId passed as a param.
  Schemes_Recommended: "/farmer-schemes/schemes/v1/recommended/_search",
  SchemeAgriInfo: "/farmer-schemes/schemes/application/v1/_get-mapping",
  DBTUserInfo: "/farmer/v1/dbt/_get",
  SchemeApply: "/farmer-schemes/schemes/application/v1/_apply",
  SchemeApplyEligibilityCheck:
    "/farmer-schemes/schemes/application/v1/apply-eligibility/_check",
  OTP_Send: "/user-otp/v1/_send",
  FARMER_DBT_DATA: "/farmer/v1/dbt/_get",
  support_OTP_Send: "/dfs-otp/v1/_send",
  complaint_pdf_download: "/pgr-auto-escalate/_pdfgenerate",
  create_support_grievance: "/dfs-tech-support/v1/requests/_create",
  agent_history_search: "/agent/audit/v1/_search",
  Agent_OTP_Send: "/agent/v1/otp/_send",
  Agent_Farmer_Search: "/agent/v1/entity/_search",
  Agent_Farmer_Scheme_Submit: "/agent/v1/proxy/_create",
  create_agent_farmer_grievance: `/agent/v1/proxy/_create`,
  Scheme_Recipt_Download: "/farmer-schemes/schemes/application/v1/_pdfgenerate",
  farmer_dbt_link_validation: `/farmer/v1/dbt/_linked`,
  // Mobile-parity individual DBT endpoints (pre-auth farmer onboarding/recovery).
  // Used for OTP-first registration branch + Recover DBT ID — NOT for agent
  // dbtId+mobile `_linked` checks (those stay on farmer_dbt_link_validation).
  individual_dbt_registered: `/individual/v1/dbt/_registered`,
  individual_dbt_otp_captcha_challenge: `/individual/v1/dbt/otp/captcha/_challenge`,
  individual_dbt_otp_send: `/individual/v1/dbt/otp/_send`,
  individual_dbt_profile: `/individual/v1/dbt/_profile`,
  agent_mandi_search: `/agent/v1/staticData/_search`,
  global_search: `/agent/v1/staticData/_search`,
  // Per-farmer recent-search history (dfs-personalization RecentSearchController).
  // Hit directly like `jeevika` / `visit_count`, not via the staticData gateway.
  recent_search: `/dfs-personalization/recent-search/v1/_search`,
  recent_search_clear: `/dfs-personalization/recent-search/v1/_update`,
  recent_search_delete: `/dfs-personalization/recent-search/v1/specific/_update`,
  speech_to_text: `/dfs-personalization/speech-to-text/v1/_transcribe`,
  advisory_search: `/agent/v1/staticData/_search`,
  agromet_week: `/dfs-personalization/agromet/advisory/_get`,
  agromet_history: `/dfs-personalization/agromet/advisory/_history`,
  agri_tips_summary: `/agent/v1/staticData/_search`,
  seed_subsidy_search: `/agent/v1/staticData/_search`,
  facility_search: `/facility/v1/_search`,
  facility_delete: `/facility/v1/bulk/_delete`,
  // Bank Registry District/Bank/Branch cascade — hit directly (mobile's own
  // endpoint), not via the staticData gateway. Currently auth-gated; backend
  // is expected to make it publicly callable to match /assets-section.
  bankRegistryDropdown: `/facility/bank-registry/v1/dropdown/_search`,
  jeevika: `/dfs-personalization/jeevika/v1/_search`,
  // Geo-map boundary geometry (DFS-3545). GET, static/cacheable; returns a GeoJSON
  // FeatureCollection of district/block polygons. See .agent/geo-integration/.
  geoBoundaries: `/dfs-personalization/geo/boundaries/v1/_search`,
  // Public visit counter (no auth). _count records one visit and returns the
  // updated grand total; _total is read-only and never increments.
  visit_count: `/dfs-personalization/homepage/v1/visit/_count`,
  visit_total: `/dfs-personalization/homepage/v1/visit/_total`,
  dss: {
    dashboardConfig: "/dashboard-analytics/dashboard/getDashboardConfig",
    getCharts: "/dashboard-analytics/dashboard/getChartV2",
    dashboardReport: `/dashboard-report/report`,
    // Async entity-export via the dashboard-rbac-gateway (report-export = HYPHEN,
    // one segment; the gateway rewrites it to the report svc and stamps the scope
    // marker — send NO scope headers). Submit: POST `${reportExport}/{reportType}?format=CSV`
    // → {jobId}. Status: POST `${reportExport}/status/{jobId}` → ExportJob (parts[].url
    // presigned when SUCCEEDED). See notes/dashboard/reports/curls/README.md.
    reportExport: "/dashboard-analytics/report-export",
  },
  advisorySearch: `/dfs-advisory/v1/_search`,
  agriTipsSummary: `/dfs-personalization/audio-message/v1/agri-tips/_search`,
  farmer_profile: "/farmer-profile/v1/_search",
  farmer_profile_create: "/farmer-profile/v1/_create",
  farmer_profile_dbt_create: "/farmer-profile/v2/_create",
  hrmsEmployeeSearch: "/egov-hrms/employees/_search",
  farmer_applied_schemes: "/farmer-schemes/schemes/application/v1/_status",
  farmer_application_status: "/farmer-schemes/schemes/application/v1/_update",

  // ── CITIZEN-mode counterparts ─────────────────────────────────────────
  // All POST. Each accepts the citizen's auth token via RequestInfo.authToken
  // (no agent proxy envelope, no OTP). Verified on QA in PR A.
  // Reference: .agent/rewamp/cta/finishing/updated-agent-curls-needing-citizen-alt.md
  pgr_create: "/pgr-services/v2/request/_create",
  farmer_passbook_search: "/farmer-passbook/v1/_search",
  farmer_passbook_pdf: "/farmer-passbook/v1/_pdf",
  soil_card_status: "/soil-card/v1/card-status",
  soil_card_details: "/soil-card/v1/card-details",
  soil_card_target_yield: "/soil-card/v1/target-yield",
  soil_card_download_card: "/soil-card/v1/download-card",

  // ── Horticulture Service Module (DFS-3670) ──────────────────────────────
  // Marketplace Services (providers + detail-by-id) + Enquiry Bookings. Categories come from
  // MDMS (`Marketplace.Categories`), not a horti endpoint. `pageSearch` drives the listing's
  // text search (app-provided, direct — the RewampAppBar global search stays gateway-proxied).
  horti: {
    providerSearch: "/marketplace/services/v1/_search",
    providerDetail: "/marketplace/services/v1/_search",
    pageSearch: "/dfs-personalization/marketplace-services/v3/_search",
    enquiryCreate: "/marketplace/enquiry-bookings/v1/_create",
    enquiryHistory: "/marketplace/enquiry-bookings/v1/_search",
  },

  // ── Agri Input Marketplace ("Bazar") ─────────────────────────────────────
  // Dedicated `agriMarket` service (Postgres, BigHaat + Kisaanshop vendor sync) —
  // NOT MDMS. One `products` endpoint serves every product-list context via
  // SearchCriteria alone. Page search reuses the gateway-proxied global-search
  // path (see `global_search` above), scoped with GlobalSearchCriteria.modules —
  // see notes/rewamp/agriInput/apis/API-MAP.md §2/§4.
  agriInput: {
    categories: "/agriMarket/input/categories/v1/_search",
    featuredCategories: "/agriMarket/input/categories/featured/v1/_search",
    brands: "/agriMarket/input/brands/v1/_search",
    topBrands: "/agriMarket/input/top-brands/v1/_search",
    subCategories: "/agriMarket/input/sub-categories/v1/_search",
    trendingProducts: "/agriMarket/input/products/v1/trending/_search",
    products: "/agriMarket/input/products/v1/_search",
    favouritesSearch: "/agriMarket/input/favourites/v1/_search",
    favouriteUpsert: "/agriMarket/input/favourites/v1/_upsert",
  },
};
